export default __webpack_public_path__ + "static/media/img1.e67d97e3.png";